import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_URL } from '../../../config';
import { toApiError } from '../../../lib/api-error';

/**
 * Flag or unflag canonical pages as excluded from automated/bulk QA runs.
 * Accepts one id (single page) or many (a whole sub-tree of the page tree).
 */
export function useSetQaExclusion(propertyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      canonicalPageIds,
      excluded,
      reason,
    }: {
      canonicalPageIds: string[];
      excluded: boolean;
      reason?: string;
    }) => {
      const res = await fetch(
        `${API_URL}/properties/${propertyId}/canonical-pages/qa-exclusions`,
        {
          method: 'POST',
          credentials: 'include',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ canonicalPageIds, excluded, reason }),
        }
      );
      if (!res.ok) throw await toApiError(res, 'Failed to update QA exclusion');
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['site-graph', propertyId] });
      queryClient.invalidateQueries({ queryKey: ['canonical-pages', propertyId] });
    },
  });
}
